import React, { useEffect, useRef, useState } from "react";
import { CircledMinus, CircledPlus } from "../inlinesvgs/CircledPlusMinus";

export function MinimalNumberInput({
  id,
  value,
  onChange,
  min,
  max,
  step = 1,
  stepWidth = 1,
  buttons = true,
  innerRef,
  onBlur,
  className = "",
  style,
  ariaLabel,
}: {
  id?: string;
  value: number;
  onChange: (newvalue: number) => void;
  min?: number;
  max?: number;
  step?: number;
  stepWidth?: number;
  buttons?: boolean;
  innerRef?: any;
  onBlur?: any;
  className?: string;
  style?: any;
  ariaLabel?: string;
}) {
  const ref = innerRef ?? useRef<HTMLInputElement>();
  const [input, setInput] = useState(value);

  useEffect(() => {
    setValue(input);
  }, [input]);
  useEffect(() => {
    if (input != value) {
      setInput(value);
      ref.current.value = `${value}`;
    }
  }, [value]);

  const setValue = (input: number | string) => {
    let numeric = typeof input == "string" ? Number.parseFloat(input) : input;
    if (Number.isFinite(numeric)) {
      if (step) {
        numeric = Math.round(numeric / step) * step;
      }
      if (min) {
        numeric = Math.max(min, numeric);
      }
      if (max) {
        numeric = Math.min(max, numeric);
      }
      if (numeric >= min) {
        onChange(numeric);
      }
    }
  };

  const handleKeyDown = (ev) => {
    const keycode = ev.keyCode ? ev.keyCode : ev.which;
    if (keycode == 13) {
      setValue(ev.target.value);
    }
  };
  const handleOnChange = (ev) => {
    setInput(ev.target.value);
  };
  const inc = (x: number) => {
    setValue(value + x);
  };

  return (
    <div className={"input-group number-input " + className} style={style}>
      <input
        ref={ref}
        id={id}
        name={id}
        aria-label={ariaLabel}
        type="number"
        step={step}
        defaultValue={value}
        min={min}
        max={max}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
        onBlur={onBlur}
      />
      {buttons && (
        <>
          <button
            className={"input-group-addon step  minus"}
            aria-label={I18N("aria::Minus")}
            disabled={value == min}
            onClick={() => inc(-stepWidth)}
          >
            <CircledMinus />
          </button>
          <button
            className={"input-group-addon step  plus"}
            aria-label={I18N("aria::Plus")}
            disabled={value == max}
            onClick={() => inc(stepWidth)}
          >
            <CircledPlus />
          </button>
        </>
      )}
    </div>
  );
}
